export default __webpack_public_path__ + "static/media/1630646331589.dc933c94.jpeg";